import { Column } from 'react-table';

export function getAccessor(column?: Column) {
  if (!column) return undefined;
  if (!column.accessor) return undefined;
  return typeof column.accessor === 'function' ? column.id : column.accessor;
}
